export default __webpack_public_path__ + "static/media/takeflight_logo.992a10d0.png";